import { DELTA } from 'components/MapFilter/constants';
import {
  filterLocationByRaisonSociale,
  isWithingRange,
} from 'components/MapFilter/utils';
import { LocationResponse } from 'containers/ServicesPage/types';
import { pushTo } from 'helpers/routes';
import { get } from 'lodash';
import { call, put, takeLatest } from 'redux-saga/effects';
import PAGES from 'routes/pages';
import {
  getContactsFailure,
  getContactsSuccess,
  getFaqFailed,
  getLastNotificationFailed,
  getLocationsFailure,
  getLocationsSuccess,
  getVimeoThumbnailSrcFailed,
  getVimeoThumbnailSrcSuccess,
  reportBugFailed,
  reportBugSuccess,
  setFaq,
  setLastNotification,
  setNotificationReadFailed,
  setNotificationReadSuccess,
  setToasterOpen,
} from 'store/global/actions';
import {
  getContactsApi,
  getFaqApi,
  getLastNotificationBySectionApi,
  getLocalisations,
  getVimeoThumbnailSrcApi,
  reportBugApi,
  setNotificationReadApi,
} from 'store/global/api';
import {
  GET_CONTACTS,
  GET_FAQ,
  GET_LAST_NOTIFICATION,
  GET_LOCATIONS,
  GET_VIMEO_THUMBNAIL_SRC,
  REPORT_BUG,
  SET_NOTIFICATION_READ,
} from 'store/global/constants';
import {
  GetContactsType,
  GetLocationsType,
  ReportBugGeneratorType,
  setNotificationReadPayloadType,
} from 'store/global/types';
interface ResponseGenerator {
  data?: any;
}
export function* getLastNotificationBySection({
  payload,
}: {
  type: typeof GET_LAST_NOTIFICATION;
  payload: string;
}) {
  try {
    const { data: response } = yield call(getLastNotificationBySectionApi, {
      section: payload,
    });
    if (response.success) {
      const {
        message,
        type,
        title,
        action_titel: actionTitle,
        id,
        idApp,
        policyNumber,
        status,
        read,
      } = response.data[0];
      yield put(
        setLastNotification({
          lastNotification: {
            message,
            type,
            title,
            actionTitle,
            id,
            idApp,
            policyNumber,
            status,
            read,
          },
          section: type,
        }),
      );
    } else {
      yield put(getLastNotificationFailed());
    }
  } catch {
    yield put(getLastNotificationFailed());
  }
}
export function* watchGetLastNotification() {
  yield takeLatest(GET_LAST_NOTIFICATION, getLastNotificationBySection);
}
export function* setNotificationRead({
  payload,
}: {
  type: typeof SET_NOTIFICATION_READ;
  payload: setNotificationReadPayloadType;
}) {
  const { id, section, isRedirectTo = true } = payload;
  try {
    const { data: response } = yield call(setNotificationReadApi, {
      id,
    });
    if (response.success) {
      yield put(
        setNotificationReadSuccess({
          section,
        }),
      );
      if (isRedirectTo) yield call(pushTo, PAGES.NOTIFICATIONS);
    } else {
      yield put(setNotificationReadFailed());
    }
  } catch {
    yield put(setNotificationReadFailed());
  }
}

export function* watchSetNotificationRead() {
  yield takeLatest(SET_NOTIFICATION_READ, setNotificationRead);
}

export function* getLocationsSaga({ payload }: GetLocationsType) {
  yield put(getLocationsSuccess([]));
  const { filterWith, research, latitude, longitude } = payload;
  try {
    const response: ResponseGenerator = yield call(getLocalisations, {
      type: filterWith,
      curentPosition: {
        lat: latitude,
        lng: longitude,
      },
    });
    const result: LocationResponse[] = response.data.data.geoloc;
    const filteredLocations = result.filter((item: any) =>
      isWithingRange(
        item.latitude,
        item.longitude,
        latitude!,
        longitude!,
        DELTA,
      ),
    );
    yield put(
      getLocationsSuccess(
        filterLocationByRaisonSociale(filteredLocations, research),
      ),
    );
  } catch (err) {
    yield put(getLocationsFailure('Unable to fetch locations'));
  }
}

export function* watchgetLocations() {
  yield takeLatest(GET_LOCATIONS, getLocationsSaga);
}
export function* getContactsSaga({ payload }: GetContactsType) {
  try {
    const response: ResponseGenerator = yield call(getContactsApi, payload);
    yield put(getContactsSuccess(response.data.data));
  } catch (err) {
    yield put(getContactsFailure('Unable to fetch contacts'));
  }
}

export function* watchgetContacts() {
  yield takeLatest(GET_CONTACTS, getContactsSaga);
}

export function* getVimeoThumbnailSrc({
  payload,
}: {
  type: typeof GET_VIMEO_THUMBNAIL_SRC;
  payload: string;
}) {
  try {
    const response: ResponseGenerator = yield call(
      getVimeoThumbnailSrcApi,
      payload,
    );
    const thumbnailResponseUrl = get(response, 'data[0].thumbnail_medium');
    yield put(getVimeoThumbnailSrcSuccess(thumbnailResponseUrl));
  } catch (error) {
    yield put(getVimeoThumbnailSrcFailed('could not fetch image from vimeo'));
  }
}

export function* watchGetVimeoThumbnailSrc() {
  yield takeLatest(GET_VIMEO_THUMBNAIL_SRC, getVimeoThumbnailSrc);
}

export function* getFaq({ payload }: { type: typeof GET_FAQ; payload: any }) {
  try {
    const response: ResponseGenerator = yield call(getFaqApi, {
      lang: payload,
    });
    if (response.data.success) {
      yield put(setFaq(response.data.data));
    } else {
      yield put(getFaqFailed(response.data));
    }
  } catch (error) {
    yield put(getFaqFailed(error as any));
  }
}
export function* watchGetFaq() {
  yield takeLatest(GET_FAQ, getFaq);
}

export function* reportBug({ payload }: ReportBugGeneratorType) {
  try {
    const { data } = yield call(reportBugApi, payload);
    if (get(data, 'success')) {
      yield put(
        setToasterOpen({
          title: 'bugSuccessfullyReported',
          severity: 'success',
        }),
      );
    }
    yield put(reportBugSuccess());
  } catch (err) {
    yield put(
      setToasterOpen({
        title: 'defaultErrorMessage',
        severity: 'error',
      }),
    );
    yield put(reportBugFailed());
  }
}

export function* watchReportBug() {
  yield takeLatest(REPORT_BUG, reportBug);
}

export default [
  watchGetLastNotification,
  watchSetNotificationRead,
  watchgetLocations,
  watchGetVimeoThumbnailSrc,
  watchGetFaq,
  watchReportBug,
  watchgetContacts,
];
